import type { TrainerCapability } from '@zeus/index'
import { RoleEnum } from '@zeus/index'

/**
 * Le porteur peut-il faire ce que la capacité désigne (#11) ? L'Admin toujours :
 * les capacités ne limitent que le Formateur. Le Formateur selon celles de son
 * organisation — inconnues (pas encore chargées), elles ne donnent rien.
 *
 * Miroir de `CapabilityGuard` côté API, qui reste seul juge : masquer ici ne
 * protège rien, cela évite seulement d'offrir un bouton qui finirait en 403.
 */
export function can(
  role: RoleEnum | string | undefined,
  capabilities: readonly TrainerCapability[] | null,
  capability: TrainerCapability,
): boolean {
  if (role === RoleEnum.Admin) return true
  if (role === RoleEnum.Formateur) return capabilities?.includes(capability) ?? false
  return false
}
